import _ from 'lodash';
import {
    FILTERED_SEARCH_SUCCESS,
    FILTERED_SEARCH_FAILED,
    FILTERS_UPDATE,
    CATEGORIES
} from '../actions/types';

const INITIAL_STATE = {
    projects: [],
    markers: [],
    filters: [],
    categories: [],
    error: '',
    MAX_CONTRIBUTORS: 6,
    ASYNC_DELAY: 500,
    loading: false
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FILTERED_SEARCH_SUCCESS:
            return {
                ...state,
                projects: action.payload.projects,
                markers: action.payload.markers
            };
        case FILTERED_SEARCH_FAILED:
            return {
                ...state
            };
        case FILTERS_UPDATE:
            return {
                ...state,
                ...{filters: action.payload}
            };
        case CATEGORIES:
            return {
                ...state,
                categories: action.payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/filtersReducer.js